require("./brokerConvenienceTestAccordionRow.scss");

// @vendor
const React = require("react");
const PropTypes = require("prop-types");
const classnames = require("classnames");

// @components
const BrokerConvenienceTestAccordionHeader = require("../brokerConvenienceTestAccordionHeader/brokerConvenienceTestAccordionHeader");
const BrokerConvenienceTestAccordionBody = require("../brokerConvenienceTestAccordionBody/brokerConvenienceTestAccordionBody");

// @utilities
const { taggingEventHandled } = require("utilities/taggingEventHandled");

// @constants
const { PROC_BROKER_CONVENIENCE_TEST } = require("utilities/tagging");
class BrokerConvenienceTestAccordionRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false,
        };
        this.toggleAccordion = this.toggleAccordion.bind(this);
    }

    toggleAccordion() {
        const { description } = this.props;
        this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
        taggingEventHandled(
            PROC_BROKER_CONVENIENCE_TEST,
            "onClickAccordionToggle",
            description
        );
    }

    render() {
        const {
            disabled,
            description,
            icon,
            pillsConfig,
            id,
            information,
            sectionId,
            openedTogglerText,
            closedToggleText,
        } = this.props;
        const rowClassName = classnames("br-accordion-row", {
            "br-accordion-row--is-expanded": this.state.isExpanded,
        });

        return (
            <div className="br-accordion-row-wrapper">
                <div className={rowClassName}>
                    <BrokerConvenienceTestAccordionHeader
                        id={id}
                        description={description}
                        icon={icon}
                        onAccordionClick={this.toggleAccordion}
                        isExpanded={this.state.isExpanded}
                        disabled={disabled}
                        selectAccordionButton={this.props.selectAccordionButton}
                        questionId={id}
                        sectionId={sectionId}
                        pillsConfig={pillsConfig}
                        togglerText={closedToggleText}
                    />
                    <BrokerConvenienceTestAccordionBody
                        togglerText={openedTogglerText}
                        information={information}
                        disabled={disabled}
                        onAccordionClick={this.toggleAccordion}
                        id={id}
                    />
                </div>
            </div>
        );
    }
}

BrokerConvenienceTestAccordionRow.propTypes = {
    expandedRowId: PropTypes.string,
    onAccordionClick: PropTypes.func.isRequired,
    selectAccordionButton: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
    pillsConfig: PropTypes.object,
    icon: PropTypes.string,
    information: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.number,
    sectionId: PropTypes.number,
    headerToggleText: PropTypes.string,
    bodyTogglerText: PropTypes.string,
};

module.exports = BrokerConvenienceTestAccordionRow;
